import React from "react";
import { BaseEdge, getSmoothStepPath, type EdgeProps } from "@xyflow/react";

export function ConnectedEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
}: EdgeProps) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{ strokeWidth: 4, stroke: "#ff0000" }}
      />
      <circle r="8" fill="#ff0000">
        <animateMotion dur="2s" repeatCount="indefinite" path={edgePath} keyTimes="0;1" keyPoints="1;0" />
      </circle>
    </>
  );
}
